<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        color="primary" 
        v-on="on"
      >
        Create {{ type==='hrm'?'workspace':type }} Role
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :title="dialogTitle"
      :text="dialogText"
      color="green"      
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="12"
            >
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"
                label="Role Name"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="12"
            >
              <v-text-field
                v-model="level"
                v-validate="'required|min_value:2|max_value:255'"
                :error-messages="errors.collect('level')"
                data-vv-name="level"
                type="number"
                label="Role Level"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      type: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        progressing: false,
        dialog: false,
        name: null,
        level: 0,
      }
    },
    computed: {
      dialogTitle () {
        return this.type.toUpperCase() + ' Role'
      },
      dialogText () {
        return 'Create ' + this.type.toUpperCase() + ' Role'
      },
    },
    watch: {
      dialog: {
        immediate: true,
        handler (value) {
          if (value) {
            this.resetForm()
            this.$validator.resume()
          }
        },
      },
    },
    methods: {
      resetForm () {
        this.name = ''
        this.level = 0
        this.$validator.reset()
      },
      setDialog (value = false) {
        this.dialog = value
      },
      setProgressing (value = false) {
        this.progressing = value
      },
      validateForm () {
        return this.$validator.validateAll()
      },    
      submitForm () {
        this.validateForm().then((result) => {
          if (!result) return

          this.setProgressing(true)

          let url = '/api/' + this.type + '-roles'

          if (this.type === 'hrm') {
            url = '/api/' + 'roles'
          }

          this.$http.post(url, this.prepareFormData())
            .then((res) => {
              if (res.status === 201) {  
                this.$emit('created')
                this.$snack({
                  message: 'The ' + this.type + ' role is created successfully',
                })
                this.resetForm() 

                this.$validator.pause()
                this.setDialog(false)                           
              }
            })
            .catch(() => {})
            .then(() => {
              this.setProgressing(false)
            })
        })
      },
      prepareFormData () {
        return {
          name: this.name,
          level: this.level,
        }
      },
    },

  }
</script>
